import { configureProductDucks } from 'axp-product-ducks';

const configureProducts = () => {
  configureProductDucks({
    getToState: (state) => state.getIn(['modules', 'axp-maps-root', 'products'], {}),
  });
};

export default configureProducts;
